import { gql } from 'graphql-request'

export const ListSpeciGql = gql`
  query listSpecis($stationRecordNumber: String!) {
    listSpecis(request: { stationRecordNumber: $stationRecordNumber }) {
      results {
        id
        author
        breeds
        totalBales
        created
        status
        completed
      }
    }
  }
`
